import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getInviteRedirectPath } from '@/lib/inviteRedirect';

/**
 * Legacy route: /invite and /invite?token=...
 * Redirects to the canonical accept-invite page so all logic lives in AcceptInvite.tsx.
 */
export default function Invite() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  useEffect(() => {
    const target = getInviteRedirectPath(token);
    navigate(target, { replace: true });
  }, [token, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <p className="text-muted-foreground text-sm">Redirecting…</p>
      </div>
    </div>
  );
}
